/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {ToolbarComponent} from '../toolbar/toolbar.component';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'elohn-print-progress-toolbar',
    templateUrl: './print-progress-toolbar.component.html',
    styleUrls: ['./print-progress-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToolbarComponent, MatButton, MatIcon]
})
export class PrintProgressToolbarComponent {
    public queueSize = input.required<number>();
    public completedCount = input.required<number>();
    public readonly abortClicked = output()
}
